import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class RichText extends BaseOption {
  static userInterfaceComponent = {
    label: "Text",
    component: inspectorTools.RICH_TEXT_INPUT,
  };

  static defaultValue = "";
}
